<template>
  <transition :css="false" @before-enter="setup" @before-leave="setMaxHeight" @leave="hide">
    <slot />
  </transition>
</template>

<script>
// Utilities
import { timeToCSS } from 'Utils'

export default {
  name: 'TransitionCollapse',

  props: {
    time: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      active: false,
    }
  },

  computed: {
    formattedTime() {
      return timeToCSS(this.time)
    },
  },

  methods: {
    setTransition(element) {
      element.style.transition = `${this.formattedTime}s max-height ease`
    },

    setMaxHeight(element) {
      element.style.maxHeight = `${element.scrollHeight}px`
      element.style.overflow = 'hidden'
    },

    async setup(element) {
      if (!this.active) return
      this.setTransition(element)
      element.style.overflow = 'hidden'
      element.style.maxHeight = '0px'
      await this.$nextTick()
      this.setMaxHeight(element)
      setTimeout(() => {
        element.style.maxHeight = 'unset'
        element.style.overflow = 'visible'
      }, this.time)
    },

    async hide(element, done) {
      this.setTransition(element)
      this.setMaxHeight(element)
      await this.$nextTick()
      element.style.maxHeight = '0px'
      setTimeout(() => {
        done()
      }, this.time)
    },
  },

  async created() {
    if (this.$el && this.$el.nodeName === '#comment') return
    this.setup(this.$el)
    await this.$nextTick(() => (this.active = true))
  },
}
</script>

<style scoped></style>
